import React from "react";
import { FaInbox, FaPaperPlane } from "react-icons/fa";

import { MESSAGE_TABS } from "../utils/messagerieUtils";

function MessageTabs({ activeTab, onChange, receivedCount, sentCount, unreadCount }) {
  const tabs = [
    {
      id: MESSAGE_TABS.received,
      label: "Messages reçus",
      count: receivedCount,
      badge: unreadCount,
      icon: FaInbox,
    },
    {
      id: MESSAGE_TABS.sent,
      label: "Messages envoyés",
      count: sentCount,
      badge: 0,
      icon: FaPaperPlane,
    },
  ];

  return (
    <div className="mb-6 overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white p-2 shadow-sm dark:border-white/10 dark:bg-white/[0.05]">
      <div className="grid gap-2 sm:grid-cols-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={`relative inline-flex min-h-12 items-center justify-center gap-2 rounded-[1.2rem] px-4 py-3 text-sm font-bold transition ${
                isActive
                  ? "bg-slate-950 text-white shadow-lg dark:bg-white dark:text-slate-950"
                  : "text-slate-600 hover:bg-slate-50 dark:text-white/60 dark:hover:bg-white/10"
              }`}
            >
              <Icon />
              <span>{tab.label}</span>

              <span
                className={`rounded-full px-2 py-0.5 text-xs font-bold ${
                  isActive
                    ? "bg-white/15 text-white dark:bg-slate-950/10 dark:text-slate-950"
                    : "bg-slate-100 text-slate-500 dark:bg-white/10 dark:text-white/50"
                }`}
              >
                {tab.count}
              </span>

              {tab.badge > 0 && (
                <span className="absolute -right-1 -top-1 flex h-6 min-w-6 items-center justify-center rounded-full bg-red-600 px-1.5 text-xs font-bold text-white shadow-lg">
                  {tab.badge}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default MessageTabs;